import React from 'react';

const AvailableContentRight = () => {
  return <section className="text-left" style={{
    marginTop: '25px',
    paddingLeft: '50px',
    paddingTop: '15px',
    paddingBottom: '25px',
    borderTop: '1px solid #ddd',
  }}>
    <h2>
      Assessment Content
    </h2>
    <ul style={{ lineHeight: '2' }}>
      <li>Individual Diagnostic Assessments</li>
      <li>Pre-Test Assessments</li>
      <li>Practice Exercises with Instant Feedback</li>
      <li>Writing Application Activities</li>
      <li>Interactive Review Games</li>
      <li>Post-Evaluation Assessments</li>
    </ul>
    <h2>
      Progress Monitoring
    </h2>
    <ul style={{ lineHeight: '2' }}>
      <li>Progress Reporting Panel</li>
      <li>Teacher Writing Portals</li>
      <li>Virtual Badges</li>
    </ul>
  </section>
}

export default AvailableContentRight;
